import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  CircularProgress,
} from "@mui/material";
import { FiMenu } from "react-icons/fi";
import { FaUserCircle, FaChevronDown } from "react-icons/fa";
import { IoPerson, IoLockClosed, IoLogOut } from "react-icons/io5";
import UserAccount from "../Users/UserManagment/UserAccount";
import EditDetails from "../Users/UserManagment/EditDetails";
import ChangePassword from "../Users/UserManagment/ChangePassword";

const jwt = require("jsonwebtoken");

const LoadingScreen = () => (
  <Box
    sx={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(255, 255, 255, 1)",
      zIndex: 1300,
    }}
  >
    <CircularProgress />
  </Box>
);

export default function Header(props) {
  const [currentUser, setCurrentUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [toggleAccount, setToggleAccount] = useState(false);
  const [toggleEditDetails, setToggleEditDetails] = useState(false);
  const [toggleChangePass, setToggleChangePass] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetch("/api/auth/mydetails", {
      method: "GET",
      credentials: "include",
    })
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((data) => {
        if (data) setCurrentUser(data);
      })
      .catch(() => {
        const token = localStorage.getItem("gdfhgfhtkn");
        if (token) {
          try {
            setCurrentUser(jwt.decode(token));
          } catch (e) {}
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const logout = () => {
    fetch("/api/auth/logout", {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        if (res.ok) return res.json();
        else throw new Error();
      })
      .then(() => {
        localStorage.clear();
        window.location.href = "/login";
      })
      .catch(() => {});
  };

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      {loading && <LoadingScreen />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
          color: "white",
          width: "100%",
        }}
      >
        <IconButton
          aria-label="open drawer"
          onClick={props.handleDrawerOpen}
          edge="start"
          sx={{
            color: "white",
            marginRight: 1,
            ...(props.open && { display: "none" }),
          }}
        >
          <FiMenu size={24} />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body1" sx={{ mr: 1 }}>
            {currentUser?.Name ?? ""}
          </Typography>
          <IconButton color="inherit" onClick={handleClick} size="small">
            <FaChevronDown size={18} style={{ marginRight: 4 }} />
            <FaUserCircle size={28} />
          </IconButton>
        </Box>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem
            onClick={() => {
              setToggleAccount(true);
              handleClose();
            }}
          >
            <FaUserCircle size={20} style={{ marginRight: 8 }} /> Account
          </MenuItem>
          <MenuItem
            onClick={() => {
              setToggleEditDetails(true);
              handleClose();
            }}
          >
            <IoPerson size={20} style={{ marginRight: 8 }} /> Edit Details
          </MenuItem>
          <MenuItem
            onClick={() => {
              setToggleChangePass(true);
              handleClose();
            }}
          >
            <IoLockClosed size={20} style={{ marginRight: 8 }} /> Change Password
          </MenuItem>
          <MenuItem
            onClick={() => {
              logout();
              handleClose();
            }}
          >
            <IoLogOut size={20} style={{ marginRight: 8 }} /> Logout
          </MenuItem>
        </Menu>

        {currentUser && (
          <UserAccount
            open={toggleAccount}
            onClose={() => setToggleAccount(false)}
            setToggleAccount={setToggleAccount}
            currentUser={currentUser}
          />
        )}
        {currentUser && (
          <EditDetails
            open={toggleEditDetails}
            onClose={() => setToggleEditDetails(false)}
            setToggleDetails={setToggleEditDetails}
            currentUser={currentUser}
            isAuthenticated={true}
          />
        )}
        {currentUser && (
          <ChangePassword
            open={toggleChangePass}
            onClose={() => setToggleChangePass(false)}
            setChangePassword={setToggleChangePass}
            currentUser={currentUser}
            isAuthenticated={true}
          />
        )}
      </Box>
    </>
  );
}
